<template>
    <div>
        <context-menu id="cut-copy-context-menu">
            <template v-slot:default="{ data } ">
                <context-menu-item
                    v-if="data.element && data.element.templateType !== 'flex-layout'"
                    text="Copy"
                    icon="copy"
                    @click="onCopy(data)"
                />

                <context-menu-item
                    text="Cut"
                    icon="cut"
                    @click="onCut(data)"
                />
            </template>
        </context-menu>

        <context-menu id="paste-context-menu">
            <template v-slot:default="{ data }">
                <context-menu-item
                    text="Paste"
                    icon="paste"
                    :disabled="copiedElements.elements.length ? false : true"
                    @click="data.onPasteCallback(data.index)"
                />
            </template>
        </context-menu>
    </div>
</template>

<script>
import { mapState } from 'vuex';

import ContextMenu from '@/components/utilities/context-menu';
import ContextMenuItem from '@/components/utilities/context-menu-item';
import cutCopyPasteMixin from '@/mixins/cut-copy-paste';

export default {
    name: 'component-context-menu',
    components: { ContextMenu, ContextMenuItem },
    mixins: [cutCopyPasteMixin],

    computed: {
        ...mapState({
            copiedElements: state => state.page.copiedElements,
        }),
    },
};
</script>
